import { DISH_REVIEW } from '../../constants'

const getDishReviewBreadcrumbItemByBrandId = brandId => ({
  path: `/tasks/dish-review?brandSearchTerm=${brandId}`,
  type: DISH_REVIEW,
  name: 'Dish Review',
})

export default getDishReviewBreadcrumbItemByBrandId
